import { useLocation } from "react-router-dom";
import DealDetails from "./Deals";
import LeadDetails from "./Leads";
import AccountDetails from "./Accounts";
import ContactDetails from "./Contacts";

const ViewDetails = () => {
    const location = useLocation();
    const { moduleName, card, id, subFormData, basicPermissionData } = location.state || {};
    console.log("state:", location.state);

    return (
        <>
            {moduleName === "Deals" && <DealDetails
                card={card}
                id={id}
                subFormData={subFormData}
                basicPermissionData={basicPermissionData}
            />}
            {moduleName === "Leads" && <LeadDetails
                card={card}
                id={id}
                subFormData={subFormData || {}}
                basicPermissionData={basicPermissionData}
            />}
            {moduleName === "Accounts" && <AccountDetails
                card={card}
                id={id}
                subFormData={subFormData || {}}
                basicPermissionData={basicPermissionData}
            />}
            {moduleName === "Contacts" && <ContactDetails
                card={card}
                id={id}
                subFormData={subFormData || {}}
                basicPermissionData={basicPermissionData}
            />}
        </>
    )
}
export default ViewDetails;